@if (content(); as content) {
    <ds-modal>
        <ds-modal-header>
            <div slot="start">
                <div slot="title">{{ content.title }}</div>
            </div>
            <div slot="end" (click)="stay()">
                <vn-icon name="theme-ex" size="16" />
            </div>
        </ds-modal-header>
        <ds-modal-content>
            <div [innerHTML]="content.text"></div>
            <div class="generic-modal-actions">
                <button ds-button kind="secondary" variant="outline" size="large" (click)="leave()">{{ content.leaveButton }}</button>
                <button ds-button kind="primary" variant="filled" size="large" (click)="stay()">{{ content.stayButton }}</button>
            </div>
        </ds-modal-content>
    </ds-modal>
}
